import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/Home/home'
import contact from '@/components/Home/contact'
import DeliveryAndPayment from '@/components/DeliveryAndPayment/DeliveryAndPayment'
import Sales from '@/components/Sales/Sale'
import Order from '@/components/Order/order'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/DeliveryAndPayment',
      name: 'DeliveryAndPayment',
      component: DeliveryAndPayment
    },
    {
      path: '/Sales',
      name: 'Sales',
      component: Sales
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/all-routes.js